<template>
  <vs-popup class="calculate-bespoke-prices-pop-up"
            id="popup"
            :title="`PRICE GUIDE (${price_details.formulation_code})`"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <vs-alert v-if="price_details.type === 'Bespoke' && sales_order_gap_with_bespoke" active="true" class="h-full mt-2 mb-4" color="warning">
        The bespoke price was created on {{ __dateTimeFormatterToDate(price_details.price_tiers[0].updated_at) }}. (More than {{ bespoke_price_check_days }} days)
      </vs-alert>

      <vs-alert title="Attention: Shipping Prices Update!" v-if="price_details.type === 'Bespoke' && Number(price_details.shipping_cost) !== Number(price_details.current_shipping_cost)" active="true" class="h-full mt-2 mb-8" color="danger">
        Please note that the shipping prices have been revised since these bespoke prices were set. The previous shipping cost was £{{ Number(price_details.shipping_cost).toFixed(2) }}, 
        and the new cost is now £{{ Number(price_details.current_shipping_cost).toFixed(2) }}.
      </vs-alert>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickAddItemToCart)" autocomplete="off">

          <h5 class="mb-4 mt-2">Price tiers</h5>
          <vs-table stripe :data="price_details.price_tiers">

            <template slot="thead">
              <vs-th>MinOQ (KG)</vs-th>
              <vs-th>MaxOQ (KG)</vs-th>
              <vs-th>Price (Excl vat {{ account_currency }}/KG)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].from">
                  {{ data[indextr].from }}
                </vs-td>

                <vs-td :data="data[indextr].to">
                  {{ data[indextr].to }}
                </vs-td>

                <vs-td :data="data[indextr].price">
                  {{ data[indextr].price }}
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>

          <div class="vx-row mb-3 mt-8">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="quantity" name="quantity" :rules="'required'" v-slot="{ errors }">
                <small class="label">Quantity needed (KG)</small>
                <vs-input  size="large" v-on:input="onTypeQuantity" v-model="createForm.quantity"  name="quantity" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                <small class="label">Price per KG (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ account_currency }}</span>
                    </div>
                  </template>
                  <vs-input size="large" readonly v-model="createForm.price"   name="price" class=" required" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                <small class="label">Total price (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ account_currency }}</span>
                    </div>
                  </template>
                  <vs-input size="large" readonly v-model="createForm.total"   name="price" class=" required" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
          </div>

          <vs-alert v-if="!createForm.is_price_available && Number(createForm.quantity) > 0" active="true" class="h-full mt-2 mb-4" color="warning">
            {{ priceTierWarning }}
          </vs-alert>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Add </vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import { RepositoryFactory } from "@/repository/RepositoryFactory";
  const SettingsRepository = RepositoryFactory.get('settings');

  import moment from "moment"


  function initialState() {
    return {
      open: false,
      index: null,
      customerId: null,
      createForm: {
        is_price_available: false,
        quantity: null
      },
      price_details: {},
      is_only_add : false,
      bespoke_price_check_days: '',
      priceTierWarning:''
    }
  }

export default {
  name: 'CalculateProductPricePopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {
      type: String,
      default: '',
    }
  },
  methods:{
    async openPopup (price_details, index, is_only_add = false, customerId = null) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.index = index
        this.is_only_add = is_only_add
        this.customerId = customerId
        Object.assign(this.price_details, price_details)
        if(!!this.price_details.contract_price && this.price_details.contract_price.constructor === Array ) {
          this.price_details.price_tiers = this.price_details.contract_price
        }
        await this.fetchBespokePriceCheckDays()
        if(!!price_details.quantity && Number(price_details.quantity) > 0) {
          this.createForm.quantity = Number(price_details.quantity) / 1000
          this.onTypeQuantity()
        }
        this.open = true;
      } catch (error) {

      }
    },
    async fetchBespokePriceCheckDays() {
      try {
        this.bespoke_price_check_days = (await SettingsRepository.getTheItem('bespoke_price_check_days')).data.data.bespoke_price_check_days;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickAddItemToCart () {
        const payload = {
            quantity : Number(this.createForm.quantity) * 1000,
            price: (Number(this.createForm.price) / Number(this.price_details.fx_rate)).toFixed(4) ,
        }
        this.$emit('onItemUpdated',payload, this.index)
        this.open = false
    },
    onTypeQuantity() {
      const quantity = Number(this.createForm.quantity);
      const tiers = this.price_details.price_tiers;

      this.createForm.is_price_available = false;

      if (!tiers.length) {
        this.createForm.price = Number(0).toFixed(4);
        this.createForm.total = Number(0).toFixed(4);
        return;
      }

      const firstTier = tiers[0];
      const lastTier = tiers[tiers.length - 1];

      if (quantity < Number(firstTier.from)) {
        this.createForm.price = Number(firstTier.price).toFixed(4);
        this.createForm.is_price_available = false;
        this.priceTierWarning = `Entered quantity is below the minimum price tier (${firstTier.from}). The minimum tier price has been applied.`;

      } else if (quantity > Number(lastTier.to)) {
        this.createForm.price = Number(lastTier.price).toFixed(4);
        this.createForm.is_price_available = false;
        this.priceTierWarning = `Entered quantity exceeds the maximum price tier (${lastTier.to}). The highest tier price has been applied.`;

      } else {
        tiers.forEach((item, index) => {
          const min = Number(item.from);
          const max = Number(item.to);

          let matches = false;

          if (
            index > 0 &&
            Number(tiers[index - 1].to) === min
          ) {
            matches = quantity > min && quantity <= max;
          } else {
            matches = quantity >= min && quantity <= max;
          }

          if (matches) {
            this.createForm.price = Number(item.price).toFixed(4);
            this.createForm.is_price_available = true;
          }
        });
      }

      this.createForm.total = (
        Number(this.createForm.price) * quantity
      ).toFixed(2);
    },
    onClickClose () {
      this.open = false
    },
  },
  computed: {
    min_order_quantity: function () {
      return Number(this.price_details.price_tiers[0].from);
    },
    max_order_quantity: function () {
      return Number(this.price_details.price_tiers[this.price_details.price_tiers.length - 1].to);
    },
    contractQuantityExceeded: function () {
      if (this.price_details.type !== 'Contract') return false
      const balance = Number(this.price_details.contracted_quantity_balance)
      const qty = Number(this.createForm.quantity)
      return !isNaN(balance) && qty > 0 && qty > balance
    },
    sales_order_gap_with_bespoke: function () {
      let bespoke_date = moment(this.price_details.price_tiers[0].updated_at)
      let now = moment()
      let gap = now.diff(bespoke_date, 'days')
      return gap > Number(this.bespoke_price_check_days)
    }
  }
  ,
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .calculate-bespoke-prices-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 35% !important;
  }
</style>
